module.exports = __webpack_public_path__ + "img/awf_workflow.b05065c5.png";